<template>
  <sc-chart :options="chartData" />
</template>
<script>
  import { createNamespacedHelpers } from 'vuex';
  import { ScChart } from '@intelipost-js/secure-components';

  const { mapState } = createNamespacedHelpers('analytic/provider');

  export default {
    name: 'sc-chart-provider-orders',
    computed: {
      ...mapState([
        'chartDeliveredOrders',
      ]),
      withClarify() {
        return this.chartDeliveredOrders.with_clarify;
      },
      withoutClarify() {
        return this.chartDeliveredOrders.without_clarify;
      },
      chartData() {
        const { total = 0 } = this.chartDeliveredOrders;

        return {
          chart: {
            type: 'pie',
          },
          title: {
            text: `Pedidos (Total: ${total})`,
          },
          plotOptions: {
            pie: {
              allowPointSelect: true,
              cursor: 'pointer',
              dataLabels: {
                enabled: true,
                format: '<b>{point.name}</b>: {point.percentage:.1f} %',
              },
            },
          },
          series: [
            {
              name: 'Ocorrências',
              data: [
                {
                  name: 'Com ocorrência',
                  y: this.withClarify,
                  color: '#da6f6f',
                  sliced: true,
                  selected: true,
                },
                {
                  name: 'Sem ocorrência',
                  y: this.withoutClarify,
                  color: '#a4c25c',
                },
              ],
            },
          ],
        };
      },
    },
    components: {
      ScChart,
    },
  };
</script>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-analytic/features/reports/pages/provider/components/sc-chart-provider-orders/ScChartProviderOrders.vue